<template>
  <div :class="classes" class="dropdown">
    <div ref="reference" :class="`${prefixDatePickClass}-parent-input`">
      <t-input v-model="model"
               :clearable="!disabled && isClear"
               :icon="iconClass"
               icon-placement="right"
               :placeholder="placeholderText"
               readonly="readonly"
               :size="size"
               :disabled="disabled"
               @icon-click="$_onClearIconClick"
               @blur="$_onInputBlur"
               @focus="$_onSelectCalendarIconClick"
      ></t-input>
      <div v-show="visible" :class="`${prefixDatePickClass}-suspension`"></div>
    </div>
    <!--<div ref="reference" class="aid-input-wrap">-->
    <!--<a class="input-icon">-->
    <!--<i-->
    <!--v-show="!disabled && !isClear"-->
    <!--ref="referenceI"-->
    <!--class="aid aid-calendar-select icon-calendar"-->
    <!--@click="$_onSelectCalendarIconClick"-->
    <!--&gt;-->
    <!--</i>-->
    <!--<i-->
    <!--v-show="!disabled && isClear"-->
    <!--:title="t('t.datepicker.clear')"-->
    <!--class="icon-clear"-->
    <!--@click.stop="$_onClearIconClick"-->
    <!--&gt;-->
    <!--</i>-->
    <!--</a>-->
    <!--<input-->
    <!--ref="referenceInput"-->
    <!--v-model="model"-->
    <!--:disabled="disabled"-->
    <!--:class="{'input&#45;&#45;lg':size==='lg','input&#45;&#45;sm':size==='sm'}"-->
    <!--:placeholder="placeholderText"-->
    <!--type="text"-->
    <!--readonly="readonly"-->
    <!--class="input dropdown__toggle cursor-pointer"-->
    <!--@blur="$_onInputBlur"-->
    <!--@click="$_onSelectCalendarIconClick"-->
    <!--/>-->
    <!--</div>-->
    <t-pop-box
      v-show="visible"
      ref="drop"
      v-clickoutside="$_onClickOutside"
      :placement="placement"
      :class="[prefixDatePickClass, isRange ? `${prefixDatePickClass}-range` : '']"
    >
      <div :class="`${prefixDatePickClass}-content`">
        <t-date-panel
          :visible="visible"
          :type="type"
          :is-range="isRange"
          :default-draw-date="drawDate"
          :min-selected="minSelected"
          :max-selected="maxSelected"
          :show-shortcut="showShortcut"
          :shortcut-options="shortcutOptions"
          :confirm="confirmCache"
          :min-select-range="minSelectRangeCache"
          :max-select-range="maxSelectRangeCache"
          :unselectable-days-of-week="unselectableDaysOfWeek"
          @panel-pick="$_onPanelPick"
          @range-pick="$_rangePick"
        >
        </t-date-panel>
      </div>
    </t-pop-box>
  </div>
</template>

<script>
/**
 * 所有的date都是moment格式, 默认语言为中文
 */
import moment from 'moment'
import TDatePanel from './panel/date-panel.vue'
import clickoutside from '@/directives/click-outside'
import locale from '@/mixins/locale'
import Emitter from '../../mixins/emitter'
import TPopBox from '@/module/pop-box/pop-box.vue'
import Bus from '@/utils/bus'
import { PREFIX_DATE_PICK_CLASS, PREFIX_DATE_PICKER_CLASS } from './constants'
const FORMAT_MONTH = 'YYYY-MM'
const FORMAT_YEAR = 'YYYY'
const FORMAT_DATE = 'YYYY-MM-DD'
const FORMAT_TIME = 'HH:mm'
const FORMAT_TIME_RANGE = 'HH:mm:ss'
const TIME_SEPARATOR = ' '
const RANGE_SEPARATOR = ' ~ '

export default {
  name: 'TDatePicker',
  components: {
    TDatePanel,
    TPopBox
  },
  directives: { clickoutside },
  mixins: [locale, Emitter],
  props: {
    alignRight: Boolean,
    type: {
      // 可能的取值为：month|monthRange|date|dateRange|dateTime|dateTimeRange|time
      type: String,
      default: 'date'
    },
    rangeSeparator: {
      type: String,
      default: RANGE_SEPARATOR
    },
    clearable: {
      type: Boolean,
      default: false
    },
    showToday: {
      type: Boolean,
      default: false
    },
    showShortcut: {
      type: Boolean,
      default: false
    },
    shortcutOptions: {
      type: Object,
      default() {
        return {}
      }
    },
    size: {
      type: String,
      default: ''
    }, // 可能的取值为：large,small,normal(default)
    // eslint-disable-next-line
    placeholder: {
      type: String
    },
    format: {
      type: String,
      default: ''
    },
    disabled: Boolean,
    value: {
      type: [String, Array],
      default: ''
    },
    confirm: {
      type: Boolean,
      default: true
    },
    minSelectRange: {
      type: String,
      default: ''
    },
    maxSelectRange: {
      type: String,
      default: ''
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    unselectableDaysOfWeek: {
      type: Array,
      default: () => []
    },
    limitDate: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      iconClose: false,
      isFocus: false,
      visible: false,
      yearFormat: FORMAT_YEAR,
      monthFormat: FORMAT_MONTH,
      dateFormat: FORMAT_DATE,
      timeFormat: FORMAT_TIME,
      timeRangeFormat: FORMAT_TIME_RANGE,
      timeSeparator: TIME_SEPARATOR,
      valueType: 'String', // value is string or array
      minValue: '',
      maxValue: '',
      // currentValue: '',
      isButtonClick: false,
      prefixClass: PREFIX_DATE_PICKER_CLASS,
      prefixDatePickClass: PREFIX_DATE_PICK_CLASS,
      placeholderText: '',
      isLimitDate: false,
      maxData: '',
      minSelectRanged: '',
      maxSelectRanged: ''
    }
  },
  computed: {
    iconClass() {
      if (this.disabled) {
        return ''
      }
      if (this.isClear || this.iconClose) {
        return 'close-circle'
      }
      return 'calendar-outline'
    },
    isOnlyTimeType() {
      return /^time/i.test(this.type)
    },
    classes() {
      let s = `${PREFIX_DATE_PICKER_CLASS}`
      if (this.value) {
        s += ` ${PREFIX_DATE_PICKER_CLASS}--clear`
      }
      // NOTE: 样式没起作用
      // if (this.alignRight) {
      //   s += ' alignRight'
      // }
      return s
    },
    placement() {
      if (this.alignRight) {
        return 'bottom-end'
      } else {
        return 'bottom-start'
      }
    },
    isClear() {
      if (this.clearable) {
        if (this.isRange === true) {
          return !!this.value.length
        } else {
          return !!this.value
        }
      }
      return false
    },
    // NOTE: 多余的变量
    /* selectDateValue() {
      return this.getSelectDateValue()
    }, */
    model: {
      get() {
        if (this.isRange === false) {
          if (this.minValue) {
            return moment(this.minValue, this.formatAll).format(this.formatAll)
          } else {
            return this.minValue || ''
          }
        } else {
          if (this.minValue && this.maxValue) {
            return this.minValue + this.rangeSeparator + this.maxValue
          } else {
            return ''
          }
        }
      },
      set(val, oldVal) {
        if (val !== oldVal) {
          if (this.isRange === true) {
            if (!val) {
              val = []
            } else {
              val = val.split(this.rangeSeparator)
            }
          }
          let value = val || ''
          if (this.isRange === true && !value) {
            value = []
          }
          this.visible = false
          this.$emit('input', value)
          this.$emit('date-change', value)
          this.dispatch('TFormItem', 'g-on-form-change', value)
        }
      }
    },
    formatAll() {
      if (this.type === 'dateTime' || this.type === 'dateTimeRange') {
        return this.dateFormat + this.timeSeparator + this.timeRangeFormat
      } else if (this.type === 'month' || this.type === 'monthRange') {
        return this.monthFormat
      } else if (this.type === 'year' || this.type === 'yearRange') {
        return this.yearFormat
      } else if (this.type === 'timeRange') {
        return this.timeRangeFormat
      } else if (this.type === 'time') {
        return this.timeFormat
      } else {
        return this.format || this.dateFormat
      }
    },
    showTime() {
      if (this.type === 'dateTime' || this.type === 'dateTimeRange') {
        return true
      } else {
        return false
      }
    },
    isRange() {
      if (
        this.type === 'dateRange' ||
        this.type === 'dateTimeRange' ||
        this.type === 'monthRange'
      ) {
        return true
      } else {
        return false
      }
    },
    drawDate() {
      let minSelectRanged = null
      if (this.minSelectRanged) {
        minSelectRanged = moment(this.minSelectRanged, this.formatAll)
      }
      let maxSelectRanged = null
      if (this.maxSelectRanged) {
        maxSelectRanged = moment(this.maxSelectRanged, this.formatAll)
      }
      let date = moment(this.minValue || new Date(), this.formatAll)
      let drawDate = date
      if (minSelectRanged && date.isBefore(minSelectRanged)) {
        drawDate = minSelectRanged
      }
      if (maxSelectRanged && date.isAfter(maxSelectRanged)) {
        drawDate = maxSelectRanged
      }
      drawDate.set('hour', 0)
      drawDate.set('minute', 0)
      drawDate.set('second', 0)
      return drawDate
    },
    minSelected() {
      if (this.isOnlyTimeType === false) {
        if (!this.minValue) {
          return null
        }
        let newMoment = moment(this.minValue, this.formatAll)
        if (newMoment.isValid()) {
          return newMoment
        } else {
          throw new Error(this.t('t.datepicker.dataError'))
        }
      } else {
        let newMoment
        if (!this.minValue) {
          newMoment = moment()
          // 时间被清空后默认为当前时间
          let now = new Date()
          newMoment
            .hour(now.getHours())
            .minute(now.getMinutes())
            .second(now.getSeconds())
        } else {
          newMoment = moment(this.minValue, this.formatAll)
        }
        if (newMoment.isValid()) {
          return newMoment
        } else {
          throw new Error(this.t('t.datepicker.dataError'))
        }
      }
    },
    maxSelected() {
      if (!this.maxValue) {
        return null
      }
      let newMoment = moment(this.maxValue, this.formatAll)
      if (newMoment.isValid()) {
        return newMoment
      } else {
        throw new Error(this.t('t.datepicker.dataError'))
      }
    },
    minSelectRangeCache() {
      if (!this.minSelectRanged) {
        return null
      }
      let newMoment = moment(this.minSelectRanged, this.formatAll)
      if (newMoment.isValid()) {
        return newMoment
      } else {
        throw new Error(this.t('t.datepicker.dataError'))
      }
    },
    maxSelectRangeCache() {
      if (!this.maxSelectRanged) {
        return null
      }
      let newMoment = moment(this.maxSelectRanged, this.formatAll)
      if (newMoment.isValid()) {
        return newMoment
      } else {
        throw new Error(this.t('t.datepicker.dataError'))
      }
    },
    confirmCache() {
      if (
        this.type === 'date' ||
        this.type === 'dateRange' ||
        this.type === 'year' ||
        this.type === 'month' ||
        this.type === 'monthRange'
      ) {
        return this.confirm
      } else {
        return true
      }
    }
  },
  watch: {
    // selectDateValue(newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     if (this.isRange === true) {
    //       if (!newVal) {
    //         newVal = []
    //       } else {
    //         newVal = newVal.split(this.rangeSeparator)
    //       }
    //     }
    //     this.publishDate(newVal)
    //   }
    // },
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$_setValue(newVal)
      }
    },
    visible(val) {
      /* istanbul ignore next */
      if (val) {
        Bus.$emit('g-on-update-popper')
      }
      // } else {
      //   Bus.$emit('g-on-destroy-popper')
      // }
    },
    minSelectRanged(val) {
      // 如果当前选中的日期小于最小范围,就清空选中值
      if (this.value) {
        let value = Array.isArray(this.value) ? this.value[0] : this.value
        let formatedValue = moment(value, this.formatAll)
        let formatedMinSelectRange = moment(val, this.formatAll)
        if (formatedValue.isBefore(formatedMinSelectRange)) {
          this.$_clearDates()
        }
      }
    },
    maxSelectRanged(val) {
      // 如果当前选中的日期大于最大范围,就清空选中值
      if (this.value) {
        let value = Array.isArray(this.value) ? this.value[1] : this.value
        let formatedValue = moment(value, this.formatAll)
        let formatedMaxSelectRange = moment(val, this.formatAll)
        if (formatedValue.isAfter(formatedMaxSelectRange)) {
          this.$_clearDates()
        }
      }
    },
    placeholder(val) {
      if (!val) {
        this.placeholderText = this.t('t.datepicker.placeholder')
      } else {
        this.placeholderText = val
      }
    }
  },
  created() {
    // 使用clickoutside指令处理
    // 创建事件：点击日历外的区域关闭日历
    if (Array.isArray(this.value)) {
      this.valueType = 'Array'
    } else {
      this.valueType = 'String'
    }
    if (!this.placeholder) {
      this.placeholderText = this.t('t.datepicker.placeholder')
    } else {
      this.placeholderText = this.placeholder
    }
    if (this.value) {
      this.$_setValue(this.value)
    }
    if (this.limitDate) {
      this.isLimitDate = true
    }
    this.minSelectRanged = this.minSelectRange
    this.maxSelectRanged = this.maxSelectRange
  },
  methods: {
    // NOTE: 多余的函数
    /* getSelectDateValue() {
      if (this.isRange === false) {
        if (this.minValue) {
          return moment(this.minValue, this.formatAll).format(this.formatAll)
        } else {
          return this.minValue || ''
        }
      } else {
        if (this.minValue && this.maxValue) {
          return this.minValue + this.rangeSeparator + this.maxValue
        } else {
          return ''
        }
      }
    }, */
    $_onInputBlur() {
      /* istanbul ignore next */
      this.isFocus = false
      if (this.visible === false) {
        this.dispatch('TFormItem', 'g-on-form-blur', this.model)
      }
      // console.log(this.model)
      // console.log(this.isClear)
      // if(this.model== ''&&!this.isClear){
      //   this.minSelectRanged=''
      //   this.maxSelectRanged=''
      // }
    },
    $_onSelectCalendarIconClick() {
      if (!this.disabled && !this.visible) {
        this.visible = !this.visible
      }
      this.isFocus = true
      // 关闭其他日期控件的弹出窗 但是不能关闭自己控件的
      this.isButtonClick = this.visible
    },
    $_onClickOutside(e) {
      if (this.visible === true && this.isButtonClick === false) {
        this.visible = false
      }
      // 一次点击后还原
      if (this.isButtonClick === true) {
        this.isButtonClick = false
      }
    },
    $_onClearIconClick() {
      if (this.iconClass === 'calendar-outline') {
        this.$_onSelectCalendarIconClick()
      } else {
        this.iconClose = false
        this.$_clearDates()
        this.$emit('on-clear-date')
      }
    },
    $_clearDates() {
      this.minValue = '' // 清除用户所选值
      this.maxValue = ''
      // NOTE: 清空选择
      this.model = ''
      if (this.isLimitDate) {
        this.minSelectRanged = ''
        this.maxSelectRanged = ''
      }
    },
    $_setValue(newVal) {
      if (this.isRange === true && !Array.isArray(newVal)) {
        throw new Error(this.t('t.datepicker.dataError'))
      }
      if (Array.isArray(newVal)) {
        this.valueType = 'Array'
        if (newVal.length) {
          this.minValue = newVal[0] || ''
          this.maxValue = newVal[1] || ''
        } else {
          this.minValue = ''
          this.maxValue = ''
        }
      } else {
        this.valueType = 'String'
        this.minValue = newVal || ''
      }
    },
    $_onPanelPick(selectDate, type) {
      this.iconClose = true
      this.$_setDate(selectDate, type)
    },
    $_setDate(selectDate, type) {
      // date is moment
      let _format = this.format || this.formatAll
      if (type) {
        if (selectDate && moment.isMoment(selectDate)) {
          this[type + 'Value'] = selectDate.format(_format)
        }
      } else {
        selectDate = Array.isArray(selectDate) ? selectDate : [selectDate]
        if (selectDate[0] && moment.isMoment(selectDate[0])) {
          this.minValue = selectDate[0].format(_format)
        } else {
          this.minValue = ''
        }
        if (selectDate[1] && moment.isMoment(selectDate[1])) {
          this.maxValue = selectDate[1].format(_format)
        } else {
          this.maxValue = ''
        }
      }

      // NOTE: 这里需要设置选中的值
      if (this.isRange === false) {
        if (this.minValue) {
          this.model = moment(this.minValue, this.formatAll).format(this.formatAll)
        } else {
          this.model = this.minValue || ''
        }
      } else {
        if (this.minValue && this.maxValue) {
          this.model = this.minValue + this.rangeSeparator + this.maxValue
        } else {
          this.model = ''
        }
      }

      // 如果是空的或者没有变化直接关闭
      // NOTE: 多余判断
      /* if (
        !this.selectDateValue ||
        this.getSelectDateValue() === this.selectDateValue
      ) {
        this.visible = false
      } */
      if (this.isRange) {
        if (selectDate && selectDate.length === 2) this.visible = false
      } else {
        if (selectDate) this.visible = false
      }
    },
    // 选中日期触发函数 @params {Object} minDate,maxDate
    $_rangePick(rangDate) {
      if (this.type === 'dateRange' && this.maxSelectRange === '') {
        let format = rangDate.minDate._i
        this.maxData = rangDate.maxDate
        let minformatDate = `${format.year}-${format.month + 1}-${format.date}`
        if (this.limitDate) {
          this.minSelectRanged = minformatDate
          this.maxSelectRanged = this.$_getNewData(minformatDate, this.limitDate)
        }
      }
    },
    $_getNewData(dateTemps, days) {
      var dateTemp = dateTemps.split('-')
      var nDate = new Date(dateTemp[0] + '/' + dateTemp[1] + '/' + dateTemp[2]) // 转换为MM-DD-YYYY格式
      var millSeconds = Math.abs(nDate) + days * 24 * 60 * 60 * 1000
      var rDate = new Date(millSeconds)
      var year = rDate.getFullYear()
      var month = rDate.getMonth() + 1
      if (month < 10) month = '0' + month
      var date = rDate.getDate()
      if (date < 10) date = '0' + date
      return year + '-' + month + '-' + date
    }
    // 通知外层选取的日期
    /* NOTE: 多余的函数 */
    /* publishDate(value) {
      value = value || ''
      if (this.isRange === true && !value) {
        value = []
      }
      this.$emit('input', value)
      this.$emit('date-change', value)
      this.currentValue = value
      this.visible = false
    } */
  }
}
</script>



// WEBPACK FOOTER //
// src/module/date-picker/date-picker.vue